import { gql } from "@apollo/client";

export default gql`
  query getProfileOneononesQuery(
    $participants: [Int!]!
    $now: DateTime!
    $beforeDate: DateTime!
    $includeUpcoming: Boolean!
    $upcomingFirst: Int!
    $upcomingCursor: String
    $pastFirst: Int!
    $pastCursor: String
  ) {
    upcoming: meetings(
      isFormalOneonone: true
      participants: $participants
      startDatetime_Gte: $now
      first: $upcomingFirst
      after: $upcomingCursor
      orderBy: "start_datetime"
    ) @include(if: $includeUpcoming) {
      edges {
        node {
          id
          title
          startDatetime
          meetingGroupId
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    past: meetings(
      isFormalOneonone: true
      participants: $participants
      startDatetime_Lt: $beforeDate
      first: $pastFirst
      after: $pastCursor
      orderBy: "-start_datetime"
    ) {
      edges {
        node {
          id
          title
          startDatetime
          meetingGroupId
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
